jQuery($ => {
  if($('.o-advocates')[0]){
    $('.o-advocates__show-all').click(function(){
      $(this).closest('.o-advocates').removeClass('o-advocates--preview');
    });
  }
});